<template>

<div>
  <PageTitle :route="$route" />

  <PageRowWrapper>
    <BankAccountForm />
  </PageRowWrapper>
</div>

</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import BankAccountForm from '@/components/settings/test-registers/bankAccount/BankAccountForm'

export default {
  name: 'Users',
  components: {
    PageTitle,
    PageRowWrapper,
    BankAccountForm
  }
}
</script>
